/**
 * @desc Get the ordinal number with suffix, e.g. 1 => '1st', 4 => '4th'
 * @param {Number} n
 */
export default (n) => {
  const m = n % 100;
  return Math.floor(m / 10) === 1 ? 'th' : m % 10 === 1 ? 'st' : m % 10 === 2 ? 'nd' : m % 10 === 3 ? 'rd' : 'th';
};
